const sendEmailDataReducer = (state=[], action) => {
    switch(action.type){
        case 'FETCH_ALL_SEND_EMAIL_DATA':
            return action.payload
        default:
            return state
    }
}
export default sendEmailDataReducer;